import { render, staticRenderFns } from "./TournamentEditSeeding.vue?vue&type=template&id=214b530d&scoped=true"
import script from "./TournamentEditSeeding.vue?vue&type=script&lang=js"
export * from "./TournamentEditSeeding.vue?vue&type=script&lang=js"
import style0 from "./TournamentEditSeeding.vue?vue&type=style&index=0&id=214b530d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b530d",
  null
  
)

export default component.exports